import { useQuery } from '@tanstack/react-query';
import { dollars, endpoints } from '../api';

/**
 * The attached customer's account credit (D-372), shared by the customer line
 * and the Account credit tender so both read one answer. Only asked where this
 * deployment has account credit, and only for a customer with an account.
 */
export function useCustomerCredit(sub: string | null | undefined, enabled: boolean) {
  return useQuery({ queryKey: ['customer-credit', sub], queryFn: () => endpoints.customerCredit(sub!), enabled: Boolean(sub) && enabled, staleTime: 10_000 });
}

/** "Account credit $25.00" under the customer, so the cashier can offer it before being asked. */
export function CustomerCreditLine({ sub }: { sub: string | null | undefined }) {
  const features = useQuery({ queryKey: ['box-office-features'], queryFn: endpoints.features, staleTime: 30_000 });
  const credit = useCustomerCredit(sub, features.data?.account_credit === true);
  const account = credit.data?.credit;
  if (!account || account.balance_cents <= 0) return null;
  return (
    <p className="mt-1 text-xs text-ink-600">
      Account credit <span className="tabular font-semibold text-ink-900">{dollars(account.balance_cents)}</span>
      {account.verified ? '' : ' · not spendable until they sign in online with their email'}
    </p>
  );
}
